import { render, staticRenderFns } from "./ParcelsInfo.vue?vue&type=template&id=44996b02&scoped=true&"
import script from "./ParcelsInfo.vue?vue&type=script&lang=ts&"
export * from "./ParcelsInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ParcelsInfo.vue?vue&type=style&index=0&id=44996b02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44996b02",
  null
  
)

export default component.exports